import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/materialGroup",
    component: LayoutPage,
    children: [
      {
        path: "",
        name: "materialGroup-page",
        component: () =>
          import("../../views/MaterialGroup/MaterialGroup.vue"),
        meta: {
          title: "MaterialGroup",
          titleLocalizationCode: "Material_Group",
          desc: "Material group page",
          descLocalizationCode: "Material_Group_Page",
          sidebarElement: false,
          permissionCodes: [
            "ProductCatalog.Read",
            "ProductCatalog.Add",
            "ProductCatalog.Edit",
            "ProductCatalog.Delete",
          ],
        },
      },
    ],
  },
];
